import apiHeader from '@/helpers/apiHeader';

const formConfigService = {
	New_getFormConfig(params) {
		return apiHeader.get('general-setting/form-config', { params });
	},
	getFormConfig(params) {
		return apiHeader.get('general-setting/app-configuration/form-config', { params });
	},
	get(code) {
		return apiHeader.get(`general-setting/app-configuration/${code}`);
	},
	getConfigDataMapping(params) {
		return apiHeader.get('general-setting/app-configuration/config-data-mapping', { params });
	}	
};

export default formConfigService;
		